import React from 'react';
import { CityChip } from '../ui/CityChip';
const cities = ['Brighton', 'Howell', 'Hartland', 'Milford', 'South Lyon', 'White Lake', 'Fenton'];
export function AreasServed() {
  return <section className="py-16 bg-white border-t border-gray-100" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-24">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-25">
          Proudly Serving Local Families
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-26">
          A local martial arts school proudly serving nearby communities — not a
          statewide chain.
        </p>

        <div className="flex flex-wrap justify-center gap-3" data-id="element-27">
          {cities.map(city => <CityChip key={city} city={city} data-id="element-28" />)}
        </div>
      </div>
    </section>;
}